// extracted by mini-css-extract-plugin
module.exports = {"main":"inviteRoom_main__1Sb79","menu":"inviteRoom_menu__8RaCq"};